import React from "react";
import { IExpenseTypeRecord } from "../../../lib/types";
import { cn } from "../../../lib/utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface ExpenseCategoryIconProps {
    category: IExpenseTypeRecord;
}

export default function ExpenseCategoryIcon({ category }: ExpenseCategoryIconProps) {
    return <div className={cn(category.theme?.background, category.theme?.foreground, "flex h-10 w-10 items-center justify-center rounded-lg font-medium")}>{category.icon ? <FontAwesomeIcon icon={category.icon} size="1x" /> : category.name.charAt(0).toUpperCase() || "X"}</div>;
}
